var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-component",class:{
    [_vm.form]: true,
    [_vm.type]: true,
    'disabled': _vm.disabled,
  },attrs:{"disabled":_vm.disabled},on:{"click":_vm.emmitClick}},[(_vm.icon)?_c('Icon',{staticClass:"button-component__icon",style:({'margin-right': _vm.$slots.default ? '10px' : '0' }),attrs:{"icon":_vm.Icons[_vm.icon],"color":_vm.color}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }